import React, { Component } from "react";
import PropTypes from "prop-types";
import { uniq } from "lodash";

import Dropdown from "./Dropdown";
import FunnelChart from './FunnelChart';

const cWidth = document.body.clientWidth - (24*16);

class VisualizeFilter extends Component {
  constructor(props) {
    super(props);
    const { contract, contractData } = props;

    const functions = contract.abi.filter(
      f => f.type === "function" && !f.constant
    );
    const events = contract.abi.filter(f => f.type === "event");
    const stepOptions = functions.concat(events).map(x => ({
      text: x.name,
      value: x.name
    }));
    const allActivity = contractData.events.concat(contractData.calls);

    this.state = {
      addressThatDidStep1: [],
      addressThatDidStep1AndThen2: [],
      convPercent: 0,
      step1Value: '',
      step2Value: '',
      chartWidth: cWidth,
      functions,
      events,
      allActivity,
      stepOptions
    };
    this.updateStep1 = this.updateStep1.bind(this);
    this.updateStep2 = this.updateStep2.bind(this);
    this.recalculateSteps = this.recalculateSteps.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      chartWidth: document.body.clientWidth - (24*16)
    });
  }

  recalculateSteps() {
    const newState = {};
    // reset vars
    newState.addressThatDidStep1 = [];
    newState.addressThatDidStep1AndThen2 = [];
    newState.convPercent = 0;

    if (this.state.step1Value) {
      newState.addressThatDidStep1 = uniq(
        this.state.allActivity
          .filter(x => x.name === this.state.step1Value)
          .map(x => x.from)
      );
      if (this.state.step2Value) {
        newState.addressThatDidStep1AndThen2 = uniq(
          this.state.allActivity
            .filter(
              x =>
                x.name === this.state.step2Value &&
                newState.addressThatDidStep1.includes(x.from)
            )
            .map(x => x.from)
        );
      }
      newState.convPercent =
        newState.addressThatDidStep1AndThen2.length /
        newState.addressThatDidStep1.length;
      if (newState.convPercent && !isNaN(newState.convPercent)) {
        newState.convPercent = Math.round(newState.convPercent * 100);
      }
      this.setState(newState);
    }
  }

  updateStep1(ev) {
    const value = ev.target.value;
    this.setState({step1Value: value});
    // TODO improve
    setTimeout(() => this.recalculateSteps(), 300);
  }

  updateStep2(ev) {
    const value = ev.target.value;
    this.setState({step2Value: value});
    // TODO improve
    setTimeout(() => this.recalculateSteps(), 300);
  }

  render() {
    const {
      contract
    } = this.props;

    return (
      <section className="Main">
        <div className="Main-header">
          <h4>{contract.name} > Funnels</h4>
        </div>
        <div className="Main-filters">
          <div className="Main-left">
            <Dropdown
              title="Accounts that..."
              large
              options={this.state.stepOptions}
              onChange={this.updateStep1}
              value={this.state.step1Value}
            />
            <Dropdown
              title="and then..."
              large
              options={this.state.stepOptions}
              onChange={this.updateStep2}
              value={this.state.step2Value}
            />
          </div>

          <div className="Main-right">
            <Dropdown
              title="In the last"
              large
              options={[
                {text: '24 hours', value: 'hours'},
                {text: '3 days', value: '3days'},
                {text: 'week', value: 'week'}
              ]}
              value="hours"
            />
          </div>
        </div>
        <div className="Main-content">
          <FunnelChart
            width={this.state.chartWidth}
            height='600'
            steps={[{
              name: this.state.step1Value,
              value: this.state.addressThatDidStep1.length,
              convPercent: 100
            }, {
              name: this.state.step2Value,
              value: this.state.addressThatDidStep1AndThen2.length,
              convPercent: this.state.convPercent
            }]}
          />
        </div>
      </section>
    );
  }
}

VisualizeFilter.propTypes = {
  contract: PropTypes.object,
  contractData: PropTypes.object
};

export default VisualizeFilter;



// WEBPACK FOOTER //
// ./src/components/VisualizeFilter.js